<template>
  <div class="PersonelIoInfoInDateListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("DayName"),
          value: "enterDayName",
        },
        {
          text: this.$t("EntryDate"),
          value: "BEGINDATE",
        },
        {
          text: this.$t("KartEntryTime"),
          value: "BBEGINTIME",
        },
        {
          text: this.$t("EntryTime"),
          value: "BEGINTIME",
        },
        {
          text: this.$t("KartExitTime"),
          value: "BENDTIME",
        },
        {
          text: this.$t("ExitTime"),
          value: "ENDTIME",
        },
        {
          text: this.$t("KartExitDate"),
          value: "BENDDATE",
        },
        {
          text: this.$t("ExitDate"),
          value: "ENDDATE",
        },
        
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>